<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { revenueChart } from "./data-profile";
import Stat from "@/components/widgets/stat";
import { mapGetters, mapActions } from "vuex";

/**
 * Contacts-Profile component
 */
export default {
  page: {
    title: "Patient rofile",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Stat },
  data() {
    return {
      patient_id: this.$route.params.patient_id,
      revenueChart: revenueChart,
      title: "Patient Profile",
      items: [
        {
          text: "All Clients",
          href: "/",
        },
        {
          text: "Profile",
          active: true,
        },
      ],
      statData: [
        {
          icon: "bx bx-check-circle",
          title: "Completed Projects",
          value: "125",
        },
        {
          icon: "bx bx-hourglass",
          title: "Pending Projects",
          value: "12",
        },
        {
          icon: "bx bx-package",
          title: "Total Revenue",
          value: "36,524",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      FetchPatientRealProfile: "patients/fetchPatientRealProfile",
    }),
  },
  computed: {
    ...mapGetters("patients", ["PatientProfileDetails"]),
  },
  created() {
    this.FetchPatientRealProfile(this.$route.params.patient_id);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="form-group">
      <button @click="$router.go(-1)" class="btn btn-success mb-2">
        <i class="fas fa-arrow-circle-left"></i> Go Back
      </button>
    </div>
    <div class="row">
      <div class="col-xl-4">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-3">
                  <h5 class="text-primary">
                    {{
                      PatientProfileDetails ? PatientProfileDetails.patientCode : "---"
                    }}
                  </h5>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-sm-4">
                <div class="avatar-md profile-user-wid mb-4">
                  <img
                    src="@/assets/images/users/avatar-1.jpg"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-nowrap mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Code :</th>
                      <td>
                        {{
                          PatientProfileDetails
                            ? PatientProfileDetails.patientCode
                            : "---"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Name :</th>
                      <td>
                        {{
                          PatientProfileDetails
                            ? PatientProfileDetails.patientName
                            : "---"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Mobile :</th>
                      <td>
                        {{
                          PatientProfileDetails
                            ? PatientProfileDetails.patientContact
                            : "---"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">E-mail :</th>
                      <td>
                        {{
                          PatientProfileDetails
                            ? PatientProfileDetails.patientEmail
                            : "---"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Location :</th>
                      <td>
                        {{
                          PatientProfileDetails
                            ? PatientProfileDetails.patientAddress
                            : "---"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="row">
          <div class="col-md-4">
            <Stat
              :icon="'fa fa-asterisk'"
              :title="'Visits'"
              :value="`${
                PatientProfileDetails ? PatientProfileDetails.all_visits.length : 0
              }`"
            />
          </div>
          <div class="col-md-4">
            <Stat :icon="'fa fa-clock'" :title="'Appointments'" :value="'0'" />
          </div>
          <div class="col-md-4">
            <Stat :icon="'fa fa-money'" :title="'Balance'" :value="'0'" />
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">VISITS GRAPH</h4>
            <div id="revenue-chart" class="apex-charts"></div>
            <apexchart
              class="apex-charts"
              type="bar"
              height="184"
              :series="revenueChart.series"
              :options="revenueChart.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">
            ALL VISITS FOR
            <b>{{
              PatientProfileDetails
                ? PatientProfileDetails.patientName.toUpperCase()
                : "---"
            }}</b>
            <!-- <button class="btn btn-primary btn-sm float-end">
              <i class="fa fa-print"></i> Print All Visit
            </button> -->
          </h4>
          <br />

          <div role="tablist">
            <b-card
              no-body
              class="mb-1 shadow-none"
              v-for="(visit, index) in PatientProfileDetails
                ? PatientProfileDetails.all_visits.slice().reverse()
                : []"
              :key="index"
            >
              <b-card-header
                header-tag="header"
                role="tab"
                :style="
                  visit.status ? 'background-color: #34c38f' : 'background-color: blue'
                "
              >
                <h6 class="m-0">
                  <a v-b-toggle.accordion-1 class="text-light" href="javascript: void(0);"
                    >Visit on {{ visit.visitDate
                    }}<sup v-if="visit.status == 1" class="badge badge-pill badge-light"
                      >Active</sup
                    >
                    <sup class="badge badge-pill badge-light" v-else>Closed</sup>
                  </a>
                  <!-- <button class="btn btn-light btn-sm float-end">Print Visit</button> -->
                </h6>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body
                  :class="
                    visit.status ? 'border border-success' : 'border border-primary'
                  "
                >
                  <b-card-text>
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <tbody>
                          <tr>
                            <td>
                              Temperature :
                              <span class="text-primary">{{
                                visit.temp ? visit.temp + " &#x2103;" : "---"
                              }}</span>
                            </td>
                            <td>
                              Pressure :
                              <span class="text-primary">
                                {{
                                  visit.pressure ? visit.pressure + " mmHg" : "---"
                                }}</span
                              >
                            </td>
                            <td>
                              Weight :
                              <span class="text-primary">
                                {{ visit.weight ? visit.weight + " kg" : "---" }}</span
                              >
                            </td>
                            <td>
                              Pulse :
                              <span class="text-primary">
                                {{ visit.pulse ? visit.pulse + " b/min" : "---" }}</span
                              >
                            </td>
                            <td>
                              Mauc :
                              <span class="text-primary">{{
                                visit.muac ? visit.muac + " cm" : "---"
                              }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="table-responsive">
                      <h4>Ordered Services</h4>
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">SERVICE</th>
                            <th scope="col">QTY</th>
                            <th scope="col">COST</th>
                            <th scope="col">TIME</th>
                            <th scope="col">STATUS</th>
                            <th scope="col">PAY TYPE</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(service, index) in visit ? visit.patientservices : []"
                            :key="index"
                          >
                            <td>{{ service.service ? service.service.name : "--" }}</td>
                            <td>{{ service.serviceQty ? service.serviceQty : "--" }}</td>
                            <td>
                              {{ service.servicePrice ? service.servicePrice : "--" }}
                            </td>
                            <td>{{ service.added_at ? service.added_at : "--" }}</td>
                            <td>
                              {{ service.serviceStatus == "0" ? "Pending..." : "Done" }}
                            </td>
                            <td>
                              {{ service.insured == "1" ? "Insurance" : "Personal" }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr
                            v-for="(service, index) in visit ? visit.labrequests : []"
                            :key="index"
                          >
                            <td>{{ service.test.name }}</td>
                            <td>{{ service.quantity ? service.quantity : "--" }}</td>
                            <td>{{ service.amount ? service.amount : "--" }}</td>
                            <td>{{ service.date ? service.date : "--" }}</td>

                            <td>Pending...</td>
                            <td>
                              {{ service.insured == "1" ? "Insurance" : "Personal" }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr
                            v-for="(service, index) in visit ? visit.completetests : []"
                            :key="index"
                          >
                            <td>{{ service.test.name }}</td>
                            <td>{{ service.quantity ? service.quantity : "--" }}</td>
                            <td>{{ service.cost ? service.cost : "--" }}</td>
                            <td>{{ service.orderDate ? service.orderDate : "--" }}</td>
                            <td>Done</td>
                            <td>
                              {{ service.insured == "1" ? "Insurance" : "Personal" }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="table-responsive">
                      <div v-for="(note, index) in visit.clinicnotes" :key="index">
                        <h5 class="text-primary mt-2">
                          Patient Notes For {{ note.service }}
                        </h5>
                        <table border="1" cellpadding="3" cellspacing="3" width="100%">
                    
                          <tr style="border: 1px solid #ddd" v-show="note.patientHistory">
                            <th width="25%" style="padding: 6px">Patient history:</th>
                            <td style="padding: 6px">
                              <article v-html="note.patientHistory"></article>
                            </td>
                          </tr>
                          <tr style="border: 1px solid #ddd" v-show="note.patientExam">
                            <th width="25%" style="padding: 6px">
                              Physical examination:
                            </th>
                            <td style="padding: 6px" width="75%">
                              <article v-html="note.patientExam"></article>
                            </td>
                          </tr>
                      
                        
                          <tr style="border: 1px solid #ddd" v-show="note.finalDiagnosis || note.patientFinalDiagnosis ">
                            <th width="25%" style="padding: 6px">Final diagnosis:</th>
                            <td style="padding: 6px" width="75%">
                     
                             <article
                     v-if="note.version==1"
                      v-html="note.finalDiagnosis ? note.finalDiagnosis : ''"
                    ></article>
                     <span v-for="(final, index) in note.patientFinalDiagnosis" :key="index"
                     v-else
                      ><span class="compla"
                        ><button type="button" class="btn btn-light btn-sm">
                          {{ final.name, }}
                        </button></span
                      ></span
                    >
                            
                            </td>
                          </tr>
                          <tr
                            style="border: 1px solid #ddd"
                            v-show="note.diagnosisDetails"
                          >
                            <th width="25%" style="padding: 6px">diagnosis details:</th>
                            <td style="padding: 6px" width="75%">
                              <article v-html="note.diagnosisDetails"></article>
                            </td>
                          </tr>

                          <tr
                            style="border: 1px solid #ddd"
                            width="100%"
                            v-show="note.recommendation"
                          >
                            <th width="25%" style="padding: 6px">Recommendation:</th>
                            <td style="padding: 6px" width="75%">
                              <article
                                v-html="note.recommendation ? note.recommendation : '---'"
                              ></article>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div
                        class="table-responsive mt-3"
                        v-show="visit.prescriptions ? visit.prescriptions.length : 0"
                      >
                        <h4>Prescriptions</h4>
                        <table class="table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th scope="col">S/N</th>
                              <th scope="col">DRUG</th>
                              <th scope="col">QUANTITY</th>
                              <th scope="col">COST</th>
                              <th scope="col">PAYMENT TYPE</th>
                              <th scope="col">MEDICATION</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(drug, index) in visit.prescriptions" :key="index">
                              <th scope="row">{{ index + 1 }}</th>
                              <td>{{ drug.item.drug }}</td>
                              <td>{{ drug.itemQty }}</td>
                              <td>{{ drug.itemPrice }}</td>
                              <td>
                                {{ drug.insured==1 ? 'Insured' : 'Personal' }}
                              </td>
                              <td>
                                {{ drug.medication ? drug.medication : "----" }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
              <br />
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
